<template>
  <div>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='col-lg-12' style='padding:0px'>
        <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
          <ul>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
        <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='success'>
          {{success}}
        </div>
        <div class='col-lg-12' style='padding:5px 0px 5px 0px;margin: 0px'>
          <div class="form-group input-group" style='margin: 0px'>
            <span class="input-group-addon" style='padding:5px;'>مبيعات سابقة</span>
            <select @change= "recordChange()" class="form-control" style="padding: 0px" v-model="recordID">
              <option v-for="record in allRecords" :key="record.id" :value="record.id">
                {{ record.id === 0 ? '[فاتورة جديدة]' : record.sale_date + ' => [' + record.total_amount + ' ج]' }}
              </option>
            </select>
            <span class="input-group-addon" style="padding:5px; width: 100px;">{{ record.id }}</span>
            <span v-show="record.id >   0" class="input-group-addon" style="padding:5px;">
              <button  @click='deleteData()' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
            </span>
          </div>
        </div>

        <div :class="record.payment_type == 1 ? 'col-lg-12 col-md-12 col-sm-12' : 'col-lg-8 col-md-8 col-sm-8'" style="padding:5px;">
        <div class='col-lg-3 col-sm-3' style='padding:5px;'>
          <label>طريقة الدفع:</label>
          <select @change="recalculateItemsPrices()" class="form-control" style="padding: 0px" v-model="record.payment_type">
            <option  v-for="type in Paytypes" v-bind:key="type.id"  v-bind:value="type.id">
              {{type.name}}
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-md-3 col-sm-3' style='padding:5px;'>
          <label>التاريخ:</label>
          <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.sale_date'></Datepicker>
        </div>
        <div class='col-lg-6 col-md-6 col-sm-5' style='padding:5px;'>
          <label>الفنى:</label>
          <select class="form-control" style="padding: 0px" v-model="record.technical_id">
            <option v-for="item in technicals" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3"  style='padding:5px;'>
          <label>الاجمالى:</label>
          <input  @keypress="isLocked($event)" v-model='record.total_amount' onpaste="return false" onkeydown="return false" autocomplete="off" class='form-control' name='amount' type='text'>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3"  style='padding:5px;'>
          <label>الخصم:</label>
          <input  @keypress="isNumber($event)" v-on:input='calcTotalItems()' class='form-control' onpaste="return false" autocomplete="off" v-model='record.discount' name='discount' type='text'>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3"  style='padding:5px;'>
          <label>المطلوب</label>
          <input  @keypress="isLocked($event)" class='form-control' v-model='record.net_amount' onpaste="return false" onkeydown="return false" autocomplete="off" name='amount' type='text'>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3"  style='padding:5px;'>
          <label>{{inputLable}}:</label>
          <input @keypress="record.payment_type == 2 ? isNumber($event) : isLocked($event)" v-on:input='calcTotalItems()' v-model='record.paid_advance' onpaste="return false" autocomplete="off" class='form-control' name='amount' type='text'>
        </div>
        <div v-if="record.payment_type == 2" class='col-lg-4 col-sm-4' style='padding:5px;'>
          <label>ت سداد المقدم:</label>
          <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.advance_payment_date'></Datepicker>
        </div>
        <div v-if="record.payment_type == 2" class='col-lg-4 col-sm-4' style='padding:5px;'>
          <label>الباقى:</label>
          <input  @keypress="isLocked($event)" v-model='record.remaining_amount' onpaste="return false" onkeydown="return false" autocomplete="off" class='form-control' name='amount' type='text'>
        </div>
        <div v-if="record.payment_type == 2" class='col-lg-4 col-sm-4' style='padding:5px;'>
          <label>فترة السداد:</label>
          <select class="form-control" style="padding: 0px" v-model="record.installment_interval">
            <option v-for="item in periodMonthlyType" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div v-if="record.payment_type == 2" class='col-lg-4 col-sm-4' style='padding:5px;'>
          <label>بداية السداد:</label>
          <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.first_installment_date'></Datepicker>
        </div>
        <div v-if="record.payment_type == 2" class='col-lg-4 col-sm-4' style='padding:5px;'>
          <label>عدد الأقساط:</label>
          <select class="form-control" style="padding: 0px" v-model="record.installments_count">
            <option v-for="n in 10" :key="n" :value="n">
              {{ n }}
            </option>
          </select>
        </div>
        <div v-if="record.payment_type == 2" class='col-lg-4 col-sm-4' style='padding:5px;'>
          <label>قيمة القسط:</label>
          <input maxlength="4" @keypress="isNumber($event)" v-model='record.installment_value' onpaste="return false" autocomplete="off" class='form-control text-center' name='installment' type='text'>
        </div>
        </div>
        <div v-if = "record.payment_type == 2" class='col-lg-4 col-sm-4' style="padding: 0px">
          <div class="chat-panel panel panel-default" style="height: 277px;">
              <div class="panel-heading" style="padding: 5px; text-align: center">
                  الأقساط
              </div>
              <div class="panel-body" style="height: 212px;padding: 5px">
                <table class="compact-table">
                  <thead>
                    <tr>
                      <th>م</th>
                      <th>المبلغ</th>
                      <th>التاريخ</th>
                      <th>الاجراء&nbsp;<i v-if="this.record.installments.length > 0" class="fa fa-trash-o" style="color: red;" @click="deleteInstallment(-1)"></i></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in record.installments" v-bind:key="item.id" v-bind:value="item.id">
                      <td>{{index + 1}}</td>
                      <td>{{item.amount}}</td>
                      <td>{{item.due_date}}</td>
                      <td><i class="fa fa-trash-o" style="color: red;" @click="deleteInstallment(index)"></i></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                class="panel-footer"
                style="padding: 5px; text-align: center"
                :class="{
                  'text-red': totalInstalls !== 0,
                  'text-green': totalInstalls === 0
                }"
              >
                فرق مبلغ الأقساط = {{ totalInstalls }}
                <div v-if="totalInstalls > 0" class="pull-right">
                <button v-if="this.record.installments.length == 0" @click="generateInstallments()" class="btn btn-xs btn-outline btn-success" type="button">توزيع</button>
              </div>
                <div v-if="totalInstalls > 0" class="pull-left">
                <button  @click="OpenAddModal()" class="btn btn-xs btn-outline btn-success" type="button">إضافة</button>
              </div>
            </div>
          </div>
          </div>
          <div class='col-lg-12 col-sm-12' style='padding: 0px 0px 0px 0px;'>
              <div class="chat-panel panel panel-default" style="height: 175px;">
                  <div class="panel-heading" style="padding: 5px; text-align: center">
                      الأصناف
                        <div class="pull-left">
                        <button  @click="OpenItemModal()" class="btn btn-xs btn-outline btn-success" type="button">إضافة</button>
                      </div>

                  </div>

                  <div class="panel-body" style="height: 138px;padding: 5px">
                    <table class="compact-table">
                      <thead>
                        <tr>
                          <th>م</th>
                          <th>الصنف</th>
                          <th>النوع</th>
                          <th>السعر</th>
                          <th>الاجراء</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in record.items.filter(i => i.state !== 'deleted')"  v-bind:key="item.id" v-bind:value="item.id">
                          <td>{{index + 1}}</td>
                          <td>{{item.item}}</td>
                          <td>{{ itemTypesMap[item.condition] || '' }}</td>
                          <td>{{item.amount}}</td>
                          <td><i class="fa fa-trash-o" style="color: red;" @click="deleteItemData(item.id)"></i></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
              </div>
          </div>
        <div class='col-lg-4 col-sm-4  col-lg-offset-4  col-sm-offset-4' style='padding: 0px 0px 0px 10px;text-align:center;'>
          <button v-show="record.id > -1" @click='saveData()'   type='button' class='btn btn-block btn-outline btn-sm btn-success'>حفظ</button>
        </div>
        <!-- /.col-lg-6 -->
      </div>
    </div>
    <!-- /.container-fluid -->
    <!-- ======================= Add Modale Start -->
    <div v-if="showAddModal" class="custom-centered-modal">
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="showAddModal = false">&times;</button>
            <h4 class="modal-title text-center">{{ addModalTitle }}</h4>
          </div>

          <div class="modal-body">
              <div class="form-group input-group">
                <span class="input-group-addon" style='padding:5px;'>المبلغ</span>
                <input  @keypress="isNumber($event)" v-model='installmentRecord.amount' class='form-control' name='amount' type='text'>
            </div>
            <div class="form-group input-group">
              <span class="input-group-addon" style='padding:5px;'>تاريخ الاستحقاق:</span>
              <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='installmentRecord.due_date'></Datepicker>
          </div>
            </div>

          <div class="modal-footer">
            <button @click='saveInstallmentData()'  type='button' class='btn btn-outline btn-sm btn-success'>حفظ</button>
            <button class='btn btn-outline btn-sm btn-default' @click="showAddModal = false">إغلاق</button>
          </div>
        </div>
      </div>
    </div>
    <!-- ======================= Add Modale End -->
    <!-- ======================= Items Modale Start -->
    <div v-if="showItemModal" class="custom-centered-modal">
      <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="showItemModal = false">&times;</button>
            <h4 class="modal-title text-center">{{ addItemModalTitle }}</h4>
          </div>

          <div class="modal-body">
            <div class='alert alert-danger alert-dismissable' style="margin: 0px 0px 0px 0px;" v-if='validationItemErrors'>
              <ul>
                <li v-for='err in validationItemErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
              </ul>
            </div>

            <div class="form-group input-group">
              <span class="input-group-addon" style='padding:5px;'>الصنف</span>
              <span class="input-group-btn">
                <input v-on:input='itemIdChange()' style="width: 80px" maxlength="5" @keypress="isNumber($event)" v-model='itemID' onpaste="return false" autocomplete="off" class='form-control' name='itemID' type='text'>
              </span>

              <select @change="itemChange()" class="form-control" style="padding: 0px"  v-model='itemRec.item_id'>
                <option v-for="item in items" :key="item.id" :value="item.id">
                  {{ item.item }}
                </option>
              </select>
          </div>
          <div class='col-lg-6 col-sm-6' style='padding: 0px 0px 0px 0px;'>
            <div class="form-group input-group">
              <span class="input-group-addon" style='padding:5px;'>النوع</span>
              <select @change="itemChange()" class="form-control" style="padding: 0px"  v-model='itemRec.condition'>
                <option v-for="item in itemTypes" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
          <div class='col-lg-6 col-sm-6' style='padding: 0px 0px 0px 0px;'>
            <div class="form-group input-group">
              <span class="input-group-addon" style='padding:5px;'>السعر</span>
              <input
                @keypress="isLocked($event)"
                v-model='itemRec.amount'
                onpaste="return false"
                onkeydown="return false"
                autocomplete="off"
                class='form-control'
                name='amount'
                type='text'>
            </div>
          </div>
            </div>

          <div class="modal-footer">
            <button @click='saveItemData()'  type='button' class='btn btn-outline btn-sm btn-success'>حفظ</button>
            <button class='btn btn-outline btn-sm btn-default' @click="showItemModal = false">إغلاق</button>
          </div>
        </div>
      </div>
    </div>
    <!-- ======================= Items Modale End -->
  </div>
</template>
<style>
.highlight {
   background-color: #5A9EF5;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import API from '@/store/api'
import tbDate from '@/components/myComponents/tbDate'
import Swal from 'sweetalert2'
import Datepicker from 'vuejs-datepicker'
import {ar} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
export default {
  components: {
    tbDate,
    Datepicker
  },
  name: 'ItemSales',
  computed: {
    itemTypesMap () {
      const map = {}
      this.itemTypes.forEach(t => {
        map[t.id] = t.name
      })
      return map
    }
  },
  // *********************************************************************
  data () {
    return {
      itemID: '',
      recordID: 0,
      itemRec: {},
      addModalTitle: '',
      addItemModalTitle: '',
      installmentRecord: [],
      totalInstalls: 0,
      ar: ar,
      today: true,
      itemTypes: [
        {id: 1, name: 'جديد'},
        {id: 2, name: 'مستعمل'},
        {id: 3, name: 'ضمان'},
        {id: 4, name: 'هدية'}
      ],
      validationErrors: '',
      validationItemErrors: '',
      allRecords: [],
      record: {
        items: []
      },
      technicals: [],
      items: [],
      installments2Save: [],
      installmentsFixed: [],
      periodMonthlyType: [{id: null, name: ''}, {id: 1, name: 'شهرى'}, {id: 2, name: 'كل شهرين'}, {id: 3, name: 'كل 3 شهور'}, {id: 4, name: 'كل أربع شهور'}],
      Paytypes: [{id: 1, name: 'كاش'}, {id: 2, name: 'قسط'}],
      success: '',
      isLoadingData: false,
      showAddModal: false,
      showItemModal: false,
      uid: '',
      inputLable: 'المطلوب'
    }
  },
  methods: {
    // =====================================================
    async pageLoad (id, branch) {
      this.technicals = branch.technicals
      this.items = branch.items.filter(item => parseInt(item.is_contract) === 0)
      this.isLoadingData = true
      let newRecord = {
        'id': 0,
        'uid': null,
        'sale_date': null,
        'payment_type': 1,
        'technical_id': null,
        'total_amount': 0,
        'discount': 0,
        'net_amount': 0,
        'paid_advance': 0,
        'advance_payment_date': null,
        'remaining_amount': 0,
        'installment_value': null,
        'first_installment_date': null,
        'installments_count': null,
        'installment_interval': null,
        'installments': [],
        'items': []
      }
      try {
        const data = await API.getItemSales({
          id: id
        })
        if (data.length > 0) {
          this.allRecords = JSON.parse(JSON.stringify(data))
          this.allRecords.unshift(JSON.parse(JSON.stringify(newRecord)))
        } else {
          this.allRecords = []
          this.allRecords.push(JSON.parse(JSON.stringify(newRecord)))
        }
      } catch (err) {
        this.uid = null
      }
      this.isLoadingData = false
      this.recordChange()
      this.uid = id
    },
    // =====================================================
    recordChange () {
      let i = this.allRecords.map(record => record.id).indexOf(this.recordID)
      this.record = JSON.parse(JSON.stringify(this.allRecords[i]))
      this.installmentsFixed = JSON.parse(JSON.stringify(this.allRecords[i].installments))
    },
    // =====================================================
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // =====================================================
    isLocked: function (evt) {
      evt.preventDefault()
    },
    // =====================================================
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    // ============================================================
    generateInstallments () {
      this.validationErrors = []
      var isError = false
      if (parseInt(this.record.payment_type) === 2) {
        if (parseInt(this.record.installment_value) === 0 || this.record.installment_value === null || this.record.installment_value === '') {
          this.validationErrors.push('يجب ادخال قيمة القسط')
          isError = true
        }
        if (parseInt(this.record.installments_count) === 0 || this.record.installments_count === null || this.record.installments_count === '') {
          this.validationErrors.push('يجب ادخال عدد الاقساط')
          isError = true
        }
        if (this.record.installment_interval === null || this.record.installment_interval === '') {
          this.validationErrors.push('يجب اختيار فترة السداد')
          isError = true
        }
        if (!moment(this.record.first_installment_date, 'YYYY-MM-DD', true).isValid()) {
          this.validationErrors.push('يجب ادخال تاريخ بداية السداد')
          isError = true
        }
      }
      if (isError === true) {
        return
      }
      this.validationErrors = ''
      this.record.installments = []
      const baseDate = moment(this.record.first_installment_date, 'YYYY-MM-DD')
      for (let i = 0; i < this.record.installments_count; i++) {
        const due = moment(baseDate).add(i * this.record.installment_interval, 'months')
        this.record.installments.push({
          amount: this.record.installment_value,
          due_date: due.format('YYYY-MM-DD'),
          type: 0
        })
      }
      this.calcTotalInstallments()
    },
    // ============================================================
    deleteInstallment (id) {
      var text = ''
      if (id === -1) {
        text = 'ستم حذف جميع الأقساط'
      } else {
        text = 'سيتم حذف هذا القسط'
      }
      Swal.fire({
        title: 'هل أنت متأكد',
        text: text,
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      })
        .then((result) => {
          if (result.isConfirmed) {
            if (id === -1) {
              this.record.installments = []
            } else {
              this.record.installments.splice(id, 1)
            }
            this.calcTotalInstallments()
            Swal.fire({
              position: 'fixed',
              icon: 'success',
              title: 'تم الحذف بنجاح',
              showConfirmButton: false,
              timer: 1000
            })
          }
        })
    },
    // ============================================================
    OpenAddModal () {
      this.installmentRecord.id = -1
      this.addModalTitle = 'إضافة قسط'
      this.installmentRecord.due_date = ''
      this.installmentRecord.amount = ''
      this.showAddModal = true
    },
    // ============================================================
    OpenItemModal () {
      this.itemRec = {}
      this.itemID = ''
      this.itemRec =
        {
          'id': 0,
          'index': 0,
          'item_id': 0,
          'item': '',
          'amount': 0,
          'condition': 1,
          'state': 'new',
          'type': 2
        }
      this.addItemModalTitle = 'إضافة صنف'
      this.showItemModal = true
    },
    // ============================================================
    itemIdChange () {
      let i = this.items.map(record => parseInt(record.item_id)).indexOf(parseInt(this.itemID) || 0)
      if (i > -1) {
        this.itemRec.item_id = this.items[i].id
      } else {
        this.itemRec.item_id = 0
      }
      this.itemChange()
    },
    // ============================================================
    itemChange () {
      let i = this.items.map(record => record.id).indexOf(parseInt(this.itemRec.item_id) || 0)
      if (i > -1) {
        this.itemRec.item_id = this.items[i].id
        this.itemRec.item = this.items[i].item
        this.itemRec.amount = this.getItemPrice(
          this.record.payment_type,
          this.itemRec.condition,
          this.itemRec.item_id
        )
      } else {
        this.itemRec.item_id = 0
        this.itemRec.item = ''
        this.itemRec.amount = 0
      }
    },
    // ============================================================
    getItemPrice (paymentType, condition, itemId) {
      const item = this.items.find(i => i.id === parseInt(itemId))
      if (!item) return 0
      const map = {
        1: ['price', 'used_price', 'warranty_price', null],
        2: ['installment_price', 'used_installment_price', 'warranty_installment_price', null]
      }
      const key = map[paymentType] && map[paymentType][condition - 1]
      return key ? parseInt(item[key] || 0) : 0
    },
    // ============================================================
    recalculateItemsPrices () {
      this.record.items.forEach(item => {
        if (item.item_id && item.condition) {
          item.amount = this.getItemPrice(
            this.record.payment_type,
            item.condition,
            item.item_id
          )
        }
        if (item.state !== 'deleted' && item.state !== 'new') {
          item.state = 'updated'
        }
      })
      this.calcTotalItems()
    },
    // ============================================================
    saveItemData () {
      this.validationItemErrors = []
      var isError = false
      // ------------------------------------------------
      if (this.itemRec.item_id === 0 || this.itemRec.item_id === '' || this.itemRec.item_id === null) {
        this.validationItemErrors.push('يجب اختيار الصنف')
        isError = true
      }
      // ------------------------------------------------
      if (isError === false) {
        this.validationItemErrors = ''
        if (this.itemRec.id === 0) {
          this.itemRec.id = 'temp_' + Date.now() + Math.floor(Math.random() * 1000)
          this.record.items.push(this.itemRec)
        } else {
          let r = this.record.items.map(record => record.id).indexOf(this.itemRec.id)
          this.record.items.splice(r, 1, this.itemRec)
        }
        this.calcTotalItems()
        this.OpenItemModal()
      }
    },
    // ============================================================
    deleteItemData (id) {
      Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف هذا الصنف من الفاتورة؟',
        icon: 'question',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      })
        .then((result) => {
          if (result.isConfirmed) {
            let i = this.record.items.map(record => record.id).indexOf(id)
            if (this.record.items[i].state === 'new') {
              this.record.items.splice(i, 1)
            } else {
              this.record.items[i].state = 'deleted'
            }
            this.calcTotalItems()
          }
        })
    },
    // ============================================================
    calcTotalItems () {
      let total = 0
      for (let item of this.record.items.filter(item => item.state !== 'deleted')) {
        total += parseInt(item.amount || 0)
      }
      this.record.total_amount = total
      if (parseInt(this.record.discount || 0) > parseInt(this.record.total_amount || 0)) {
        this.record.discount = this.record.total_amount
      }
      this.record.net_amount = parseInt(this.record.total_amount || 0) - parseInt(this.record.discount || 0)
      if (this.record.payment_type === 1) {
        this.inputLable = 'المدفوع'
        this.record.paid_advance = this.record.net_amount
        this.record.advance_payment_date = null
        this.record.remaining_amount = 0
        this.record.first_installment_date = null
        this.record.installment_value = null
        this.record.installments_count = null
        this.record.installment_interval = null
        this.record.installments = []
        this.totalInstalls = 0
      } else {
        this.inputLable = 'المقدم'
        this.record.remaining_amount = parseInt(this.record.net_amount || 0) - parseInt(this.record.paid_advance || 0)
      }
      this.calcTotalInstallments()
    },
    // ============================================================
    saveInstallmentData () {
      let i = this.record.installments.map(record => record.due_date).indexOf(moment(this.installmentRecord.due_date).format('YYYY-MM-DD'))
      if (i > -1) {
        if (this.installmentRecord.id !== i) {
          Swal.fire({
            position: 'fixed',
            icon: 'error',
            title: 'هذا التاريخ موجود بالفعل في الأقساط.',
            showConfirmButton: false,
            timer: 3000
          })
          return
        }
      }
      if (this.installmentRecord.id === -1) {
        this.record.installments.push({
          amount: this.installmentRecord.amount,
          due_date: moment(this.installmentRecord.due_date).format('YYYY-MM-DD'),
          paid: 0,
          payment_type: this.record.id,
          type: 0
        })
      } else {
        this.record.installments[this.installmentRecord.id].due_date = moment(this.installmentRecord.due_date).format('YYYY-MM-DD')
        this.record.installments[this.installmentRecord.id].amount = this.installmentRecord.amount
      }
      this.calcTotalInstallments()
      this.record.installments.sort((a, b) => {
        return moment(a.due_date).diff(moment(b.due_date))
      })
      this.showAddModal = false
    },
    // ============================================================
    calcTotalInstallments () {
      var totalInstalls = 0
      for (const item of this.record.installments) {
        totalInstalls += parseInt(item.amount)
      }
      this.totalInstalls = parseInt(this.record.remaining_amount || 0) - parseInt(totalInstalls)
    },
    // ==================================================================
    async saveData () {
      this.success = ''
      this.validationErrors = []
      var isError = false
      if (!moment(this.record.sale_date, 'YYYY-MM-DD', true).isValid()) {
        this.validationErrors.push('يجب ادخال التاريخ')
        isError = true
      }
      if (parseInt(this.record.technical_id) === 0 || this.record.technical_id === null || this.record.technical_id === '') {
        this.validationErrors.push('يجب اختيار الفنى')
        isError = true
      }
      if (parseInt(this.record.payment_type) === 2) {
        if (parseInt(this.record.remaining_amount) === 0 || this.record.remaining_amount === null || this.record.remaining_amount === '') {
          this.validationErrors.push('يجب ان يكون الباقى اكبر من صفر ')
          isError = true
        }
        if (!moment(this.record.advance_payment_date, 'YYYY-MM-DD', true).isValid()) {
          this.validationErrors.push('يجب ادخال تاريخ سداد المقدم')
          isError = true
        }
        if (this.record.installment_interval === null || this.record.installment_interval === '') {
          this.validationErrors.push('يجب اختيار فترة السداد')
          isError = true
        }
        if (!moment(this.record.first_installment_date, 'YYYY-MM-DD', true).isValid()) {
          this.validationErrors.push('يجب ادخال تاريخ بداية السداد')
          isError = true
        }
        if (parseInt(this.record.installments_count) === 0 || this.record.installments_count === null || this.record.installments_count === '') {
          this.validationErrors.push('يجب ادخال عدد الاقساط')
          isError = true
        }
        if (parseInt(this.record.installment_value) === 0 || this.record.installment_value === null || this.record.installment_value === '') {
          this.validationErrors.push('يجب ادخال قيمة القسط')
          isError = true
        }
      }
      if (isError === true) {
        return
      }
      this.validationErrors = ''
      if (this.totalInstalls !== 0) {
        this.validationErrors = ['عفوا قيمة الاقساط غير صحيحة']
      } else if (this.record.items.length === 0) {
        this.validationErrors = ['لا توجد اصناف  مضافة']
      } else {
        this.installments2Save = []
        this.installments2Save = JSON.parse(JSON.stringify(this.installmentsFixed))
        for (const item of this.record.installments) {
          item.type = 0
        }
        // --------------------------------------
        for (const item of this.installments2Save) {
          let i = this.record.installments.findIndex(x => x.due_date === item.due_date)
          if (i > -1) {
            if (parseInt(this.record.installments[i].amount) !== parseInt(item.amount)) {
              item.amount = parseInt(this.record.installments[i].amount)
              item.type = 1 // update
            }
            this.record.installments[i].type = 1
          } else {
            item.type = -1
          }
        }
        // --------------------------------------
        for (const item of this.record.installments) {
          if (item.type === 0) {
            this.installments2Save.push({
              id: 0,
              amount: parseInt(item.amount),
              due_date: item.due_date,
              type: 2 // insert
            })
            item.type = 1 // update
          }
        }
        // -------------------------------------- check total installments
        var totalInstalls = 0
        for (const item of this.record.installments) {
          totalInstalls += parseInt(item.amount)
        }
        if (parseInt(this.record.remaining_amount) !== parseInt(totalInstalls)) {
          this.validationErrors = ['خطأ فى احتساب الأقساط']
        } else {
          this.installments2Save = this.installments2Save.filter(item => item.type !== 0)
          var savedData = JSON.parse(JSON.stringify(this.record))
          savedData.items = this.record.items
          savedData.installments = this.installments2Save
          savedData.uid = this.uid
          this.isLoadingData = true
          try {
            const data = await API.saveItemSales(
              savedData
            )
            if (this.record.id === 0) {
              this.allRecords.push(JSON.parse(JSON.stringify(data)))
            } else {
              let i = this.allRecords.map(record => record.id).indexOf(this.record.id)
              this.allRecords.splice(i, 1, data)
            }
            this.record = data
            this.recordID = this.record.id
            this.success = 'تم الحفظ بنجاح'
          } catch (err) {
            this.validationErrors = err.errors
          }
          this.isLoadingData = false
        }
      }
    },
    // ==================================================================
    async deleteData () {
      const result = await Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف الفاتورة بالكامل!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      })
      if (result.isConfirmed) {
        try {
          await API.deleteItemSales({
            'id': this.record.uid
          })
          Swal.fire({
            position: 'fixed',
            icon: 'success',
            title: 'تم حذف السجل بنجاح',
            showConfirmButton: false,
            timer: 1000
          })
          let i = this.allRecords.map(record => record.id).indexOf(this.record.id)
          this.allRecords.splice(i, 1)
          this.recordID = 0
          this.recordChange()
        } catch (err) {
          this.validationErrors = err.errors
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Customers/ItemSales.vue